import { useEffect, useState } from 'react';
import { useSetRecoilState } from "recoil";
import { ReflexContainer, ReflexElement, ReflexSplitter } from "react-reflex";
import layoutConf from "../../config/layoutConf";

import InspectionGroup from './InspectionGroup';
import InspectionItem from './InspectionItem';
import defineConf from '../../config/defineConf';
import IncomingInspectionTargetPopView from './IncomingInspectionTargetPopView';
import InspectionResultPopView from './InspectionResultPopView';
import getSpecific from '../../lib/api/getSpecific';
import notificationState from "../../states/notificationState";

function IncomingInspectionPopView ( props ) {
    const [height, setHeight] = useState(0);
    const [selectMstGrid, setSelectMstGrid] = useState();
    const [mstApi, setMstApi] = useState();
    const [selectGroupByMaterialGrid, setSelectGroupByMaterialGrid] = useState();
    const [selectGroupItemGrid, setSelectGroupItemGrid] = useState();
    const [, setTargetGrid] = useState();
    const [, setTargetItemGrid] = useState();
    const setNotification = useSetRecoilState(notificationState);

    const handleResize = () => {
        setHeight(document.documentElement.offsetHeight - 96);
    }

    useEffect(() => {
        window.addEventListener('resize', handleResize);
        handleResize();
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const onFailure = (reason) => {
        setNotification({
            severity: "error",
            msg: reason.response ? reason.response.data : reason.message,
            open: true,
        });
    };

    const masterGridSetting = (data) => {
        setSelectMstGrid(data)
    } 

    const masterApiSetting = (api) => {
        setMstApi(api);
    }

    const groupByMaterialGridSetting = (data) => {
        setSelectGroupByMaterialGrid(data);
    }

    const groupItemGridSetting = (data) => {
        setSelectGroupItemGrid(data);
    }

    const onUpdateInspectionTarget = () => {
        setTargetGrid((grid) => {
            if(grid) {
                (async() => {
                    let result;
                    try {
                        result = await getSpecific("IncomingInspectionTargetView");
                    } catch (reason) {
                        onFailure(reason);
                        return;
                    }
                    for(let item of result.data) {
                        if(item.lotNo === grid.selectedItems[0].lotNo) {
                            grid.selectedItems[0].inspectionState = item.inspectionState;
                            grid.selectedItems[0].inspectionResultState = item.inspectionResultState;
                            grid.selectedItems[0].inspectionDate = item.inspectionDate;
                            break;
                        }
                    }
                    grid.refresh(false);
                })();
            }
            return grid;
        });
    }

    const onUpdateInspectionItem = () => {
        setTargetItemGrid((grid) => {
            if(grid && grid.selectedItems[0]) {
                (async() => {
                    // 첫 등록이면 선택 행에 inspectionId가 아직 없으므로 LOT · 검사 그룹 기준으로 다시 조회한다
                    let url = 'MomSysInspectionRslt/selfInspectionGroupItem';
                    url += `/${selectMstGrid.lotNo}`;
                    url += `/${selectGroupByMaterialGrid.inspectionGroupId}`;
                    url += '/null';

                    let result;
                    try {
                        result = await getSpecific(url);
                    } catch (reason) {
                        onFailure(reason);
                        return;
                    }

                    for(let item of result.data) {
                        if(item.inspectionItemId === grid.selectedItems[0].inspectionItemId && 
                           item.inspectionCriteriaId === grid.selectedItems[0].inspectionCriteriaId
                        ) {
                            grid.selectedItems[0].inspectionId = item.inspectionId;
                            grid.selectedItems[0].inspectionState = item.inspectionState;
                            grid.selectedItems[0].inspectionResultState = item.inspectionResultState;
                            grid.selectedItems[0].inspectionDate = item.inspectionDate;
                            // 저장한 검사 결과 · 판정 · 비고도 옮겨야 그리드의 검사 결과 칸과 다시 고른 폼이 서버 값과 같다
                            grid.selectedItems[0].determinant = item.determinant;
                            grid.selectedItems[0].qcResult = item.qcResult;
                            grid.selectedItems[0].description = item.description;
                            break;
                        }
                    }
                    grid.refresh(false);
                })();
            }
            return grid;
        });
    }

    return (
        <div style={{height: height}}>
            <ReflexContainer orientation="horizontal">
                <ReflexElement>
                    <IncomingInspectionTargetPopView
                        id="IncomingInspectionTarget"
                        masterGridSetting={masterGridSetting}
                        masterApiSetting={masterApiSetting}
                        setTargetGrid={setTargetGrid}
                    />
                </ReflexElement>

                <ReflexSplitter style={{height: layoutConf.reflex.splitterHeight}} />

                <ReflexElement flex={0.5}>
                    <ReflexContainer orientation="vertical">
                        <ReflexElement flex={0.3}>
                            {
                                (selectMstGrid)
                                ?
                                <InspectionGroup 
                                    id="InspectionGroupByMaterial" 
                                    selectMstGrid={selectMstGrid}
                                    groupByMaterialGridSetting={groupByMaterialGridSetting}
                                />
                                :
                                <></>
                            }
                        </ReflexElement>

                        <ReflexSplitter style={{width: layoutConf.reflex.splitterWidth}} />

                        <ReflexElement flex={0.5}>
                            {   
                                (selectGroupByMaterialGrid)
                                ?
                                <InspectionItem
                                    id="InspectionGroupItem" 
                                    selectMstGrid={selectMstGrid}
                                    selectGroupByMaterialGrid={selectGroupByMaterialGrid}
                                    groupItemGridSetting={groupItemGridSetting}
                                    setTargetItemGrid={setTargetItemGrid}
                                />
                                :
                                <></>
                            }
                        </ReflexElement>

                        <ReflexSplitter style={{width: layoutConf.reflex.splitterWidth}} />

                        <ReflexElement flex={0.5}>
                            {
                                (selectGroupItemGrid)
                                ?
                                <InspectionResultPopView
                                    id="inspectionResult"
                                    selectMstGrid={selectMstGrid}
                                    selectGroupItemGrid={selectGroupItemGrid}
                                    mstApi={mstApi}
                                    inspectionType={defineConf.inspectionType.INPUT_INSPECTION}
                                    onUpdateInspectionTarget={onUpdateInspectionTarget}
                                    onUpdateInspectionItem={onUpdateInspectionItem}
                                />
                                :
                                <></>
                            }
                        </ReflexElement>
                    </ReflexContainer>
                </ReflexElement>
            </ReflexContainer>
        </div>
    );
}

export default IncomingInspectionPopView;
